import { TableRow, TableCell } from "@mui/material";
import React from "react";

const TableHeader = (props) => {
    return <TableRow className="table-header">
        <TableCell>Normalized</TableCell>
        <TableCell>Label</TableCell>
        <TableCell>Value</TableCell>
        <TableCell>Action</TableCell>
    </TableRow>
}

export default TableHeader;